import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import CampaignsListPage from "./CampaignsListPage";
import CampaignDetailPage from "./CampaignDetailPage";
import WhatsappCampaignDetailPage from "./WhatsappCampaignDetailPage";

export default function Campaigns() {
  const params = useParams();
  const location = useLocation();
  const path = String(location.pathname || "");

  if (path.includes("/campaigns/whatsapp")) {
    if (params?.id) return <WhatsappCampaignDetailPage />;
    return (
      <Navigate to={{ pathname: "/campaigns", search: location.search, hash: location.hash }} replace />
    );
  }

  // Detalhe de jornada (legado) permanece acessível por URL direta.
  // O hub lista apenas envios ativos (broadcast), alinhado ao benchmark Andorinha.
  return params?.id ? <CampaignDetailPage /> : <CampaignsListPage />;
}
